// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-prologue-card[data-v-a3fe92b4] {\n  width: 100%;\n}\n.c-prologue-text[data-v-a3fe92b4] {\n  font-size: 1.25rem;\n  line-height: 2rem;\n}\n.c-half[data-v-a3fe92b4] {\n  flex: 1 1 50%;\n}\n.c-figure[data-v-a3fe92b4] {\n  max-width: 350px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
